import type { FieldReportListItem } from '@/modules/field/types';

/** Lista de relatórios: data do relatório crescente (mais antigos no topo). */
export function compareFieldReportsChronologically(
  a: Pick<FieldReportListItem, 'reportDateIso' | 'id'>,
  b: Pick<FieldReportListItem, 'reportDateIso' | 'id'>,
): number {
  const left = a.reportDateIso || '';
  const right = b.reportDateIso || '';
  const byDate = left.localeCompare(right);
  if (byDate !== 0) {
    return byDate;
  }

  return a.id - b.id;
}

export function sortFieldReportsChronologically<T extends FieldReportListItem>(
  reports: T[],
): T[] {
  return [...reports].sort(compareFieldReportsChronologically);
}
